module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/fraternity-3-large-78289d10c08adac013528d89c68a2640.jpg";